
import SvgIcon from "Theme/SvgIcon"
import { ReactComponent as SendIcon } from "../fontello/icons/svg/ic_send.svg"


const Send = ({ ...props }) => (
  <SvgIcon
    component={SendIcon}
    viewBox="0 0 1000 1000"
    {...props}
  />
)


export default Send
